import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../../../../Color.js";
import { interpolate as e } from "../GeometryUtils.js";
import { ops as r, createExpression as i, Interpolate as l, Zoom as a } from "../expression/expression.js";
import { arrayType as s, ValueType as o, valueToString as n, NumberType as u, ColorType as p, StringType as d, BooleanType as f } from "../expression/types.js";

var h = /*#__PURE__*/function () {
  function h(t, e) {
    _classCallCheck(this, h);

    var n;

    switch (this.isDataDriven = !1, this.interpolator = null, t.type) {
      case "number":
      case "color":
        n = !0;
        break;

      case "array":
        n = "number" === t.value;
        break;

      default:
        n = !1;
    }

    if (null == e && (e = t.default), Array.isArray(e) && e.length > 0 && r[e[0]]) {
      var _r = {
        number: u,
        color: p,
        string: d,
        boolean: f,
        enum: d
      };

      try {
        var _n = "array" === t.type ? s(_r[t.value] || o, t.length) : _r[t.type],
            _u = i(e, null, _n);

        this.getValue = this._buildExpression(_u, t), this.isDataDriven = !0, _u instanceof l && _u.input instanceof a && (this.interpolator = _u);
      } catch (c) {
        console.log(c.message), this.getValue = this._buildSimple(t.default);
      }

      return;
    }

    n && "interval" === e.type && (n = !1);

    var _h = e && e.stops && e.stops.length > 0;

    if (_h) {
      var _iterator = _createForOfIteratorHelper(e.stops),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _r2 = _step.value;
          _r2[1] = this._validate(_r2[1], t);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    if (this.isDataDriven = !!e && !!e.property, this.isDataDriven) {
      if (void 0 !== e.default && (e.default = this._validate(e.default, t)), _h) switch (e.type) {
        case "identity":
          this.getValue = this._buildIdentity(e, t);
          break;

        case "categorical":
          this.getValue = this._buildCategorical(e, t);
          break;

        default:
          this.getValue = n ? this._buildInterpolate(e, t) : this._buildInterval(e, t);
      } else this.getValue = this._buildIdentity(e, t);
    } else _h ? this.getValue = n ? this._buildZoomInterpolate(e) : this._buildZoomInterval(e) : (e = this._validate(e, t), this.getValue = this._buildSimple(e));
  }

  _createClass(h, [{
    key: "_validate",
    value: function _validate(t, e) {
      if ("number" === e.type) {
        if (t < e.minimum) return e.minimum;
        if (t > e.maximum) return e.maximum;
      } else "color" === e.type ? t = h._parseColor(t) : "enum" === e.type ? "string" == typeof t && (t = e.values.indexOf(t)) : "array" === e.type && "enum" === e.value ? t = t.map(function (t) {
        return "string" == typeof t ? e.values.indexOf(t) : t;
      }) : "string" === e.type && (t = n(t));

      return t;
    }
  }, {
    key: "_buildSimple",
    value: function _buildSimple(t) {
      return function () {
        return t;
      };
    }
  }, {
    key: "_buildExpression",
    value: function _buildExpression(t, e) {
      var _this = this;

      return function (r, i) {
        try {
          var _l = t.evaluate(i, r);

          return void 0 === _l ? e.default : _this._validate(_l, e);
        } catch (l) {
          return console.log(l.message), e.default;
        }
      };
    }
  }, {
    key: "_buildIdentity",
    value: function _buildIdentity(t, e) {
      var _this2 = this;

      return function (r, i) {
        var l;
        return i && (l = i.values[t.property]), void 0 !== l && (l = _this2._validate(l, e)), null != l ? l : void 0 !== t.default ? t.default : e.default;
      };
    }
  }, {
    key: "_buildCategorical",
    value: function _buildCategorical(t, e) {
      var _this3 = this;

      return function (r, i) {
        var l;
        return i && (l = i.values[t.property]), l = _this3._categorical(l, t.stops), void 0 !== l ? l : void 0 !== t.default ? t.default : e.default;
      };
    }
  }, {
    key: "_buildInterval",
    value: function _buildInterval(t, e) {
      var _this4 = this;

      return function (r, i) {
        var l;
        return i && (l = i.values[t.property]), "number" == typeof l ? _this4._interval(l, t.stops) : void 0 !== t.default ? t.default : e.default;
      };
    }
  }, {
    key: "_buildInterpolate",
    value: function _buildInterpolate(t, e) {
      var _this5 = this;

      return function (r, i) {
        var l;
        return i && (l = i.values[t.property]), "number" == typeof l ? _this5._interpolate(l, t.stops, t.base || 1) : void 0 !== t.default ? t.default : e.default;
      };
    }
  }, {
    key: "_buildZoomInterpolate",
    value: function _buildZoomInterpolate(t) {
      var _this6 = this;

      return function (e) {
        return _this6._interpolate(e, t.stops, t.base || 1);
      };
    }
  }, {
    key: "_buildZoomInterval",
    value: function _buildZoomInterval(t) {
      var _this7 = this;

      return function (e) {
        return _this7._interval(e, t.stops);
      };
    }
  }, {
    key: "_categorical",
    value: function _categorical(t, e) {
      var r = e.length;

      for (var _i = 0; _i < r; _i++) {
        if (e[_i][0] === t) return e[_i][1];
      }
    }
  }, {
    key: "_interval",
    value: function _interval(t, e) {
      var r = e.length;
      var i = 0;

      for (var _l2 = 0; _l2 < r && e[_l2][0] <= t; _l2++) {
        i = _l2;
      }

      return e[i][1];
    }
  }, {
    key: "_interpolate",
    value: function _interpolate(t, r, i) {
      var l, a;
      var s = r.length;

      for (var _e = 0; _e < s; _e++) {
        var _i2 = r[_e];

        if (!(_i2[0] <= t)) {
          a = _i2;
          break;
        }

        l = _i2;
      }

      if (l && a) {
        var _r3 = a[0] - l[0],
            _s = t - l[0],
            _o = 1 === i ? _s / _r3 : (Math.pow(i, _s) - 1) / (Math.pow(i, _r3) - 1);

        if (Array.isArray(l[1])) {
          var _t = l[1],
              _r4 = a[1],
              _i3 = [];

          for (var _l3 = 0; _l3 < _t.length; _l3++) {
            _i3.push(e(_t[_l3], _r4[_l3], _o));
          }

          return _i3;
        }

        return e(l[1], a[1], _o);
      }

      return l ? l[1] : a ? a[1] : void 0;
    }
  }], [{
    key: "_isEmpty",
    value: function _isEmpty(t) {
      for (var _e2 in t) {
        if (t.hasOwnProperty(_e2)) return !1;
      }

      return !0;
    }
  }, {
    key: "_parseColor",
    value: function _parseColor(e) {
      return Array.isArray(e) ? e : ("string" == typeof e && (e = new t(e)), e instanceof t && !this._isEmpty(e) ? t.toUnitRGBA(e) : void 0);
    }
  }]);

  return h;
}();

export { h as default };